<div class="d-flex flex-column m-3">
	<mat-radio-group [(ngModel)]="selectTime" class="mat-radio-change-price">
		<mat-radio-button *ngFor="let item of changeTime" [value]="item.id">{{ item.name }}</mat-radio-button>
	</mat-radio-group>
	<div class="publication-form" *ngIf="selectTime === 1">
		<mat-form-field appearance="fill" class="example-form-field">
			<mat-label>Wybierz date</mat-label>
			<input matInput [(ngModel)]="date" [matDatepicker]="datepicker" />
			<mat-hint>MM/DD/YYYY</mat-hint>
			<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
			<mat-datepicker #datepicker>
				<mat-datepicker-actions>
					<button mat-button matDatepickerCancel>Anuluj</button>
					<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
				</mat-datepicker-actions>
			</mat-datepicker>
		</mat-form-field>
		<mat-form-field appearance="fill" class="my-2">
			<input
				matInput
				[format]="24"
				[(ngModel)]="time"
				[ngxMatTimepicker]="pickerD"
				placeholder="Wybierz godzine"
				readonly
			/>
			<i matSuffix (click)="pickerD.open()" class="far fa-clock"></i>
		</mat-form-field>
		<div class="ngx-mtp-box-bordered">
			<ngx-mat-timepicker appendToInput="true" #pickerD></ngx-mat-timepicker>
		</div>
	</div>

	<button mat-dialog-close (click)="generateTerms()" mat-raised-button color="primary">Publikuj</button>
</div>
